<template>
  <section class="uf-earlier-feedback" aria-label="Your earlier feedback">
    <h2>Your earlier feedback</h2>
    <p ref="content" :class="{'uf-feedback-collapsed': !expanded}">{{ text }}</p>
    <v-btn v-if="overflows" text small color="primary" :aria-expanded="expanded" @click="expanded = !expanded">{{ expanded ? 'Read less' : 'Read more' }}</v-btn>
  </section>
</template>
<script>
export default {
  props: {text: {type: String, required: true}},
  data: () => ({expanded: false, overflows: false}),
  mounted() {
    if(typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(this.measure);
      this.observer.observe(this.$refs.content);
    } else window.addEventListener('resize', this.measure);
    this.measure();
  },
  beforeDestroy() { if(this.observer) this.observer.disconnect(); else window.removeEventListener('resize', this.measure); },
  watch: {text() { this.expanded = false; this.$nextTick(this.measure); }},
  methods: {
    measure() {
      const content = this.$refs.content;
      this.overflows = content.scrollHeight > parseFloat(getComputedStyle(content).lineHeight) * 3 + 1;
    }
  }
};
</script>
